import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip, Button, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import M from 'messages';
import { routes } from 'config';
import classes from './styles';

const renderNoAccessText = () => (
  <Typography sx={classes.noAccess}>
    {M.get('subscriptions.noAccess1')}
    &nbsp;
    <a style={classes.link} href={`${routes.subscriptions.path}?type=standard`} rel="noopener noreferrer">
      {M.get('subscriptions.upgrade')}
    </a>
    &nbsp;
    {M.get('subscriptions.noAccess2')}
  </Typography>
);

const CustomToolbarAction = ({
  handleOnClick,
  startIcon = null,
  btnText,
  tooltipText = '',
  className = '',
  variant = 'text',
  disabled = false,
  isAvailable = true,
}) => (
  <Box sx={classes.box}>
    <Tooltip
      title={isAvailable ? tooltipText : renderNoAccessText()}
      PopperProps={{
        sx: {
          '& .MuiTooltip-tooltip': isAvailable ? {} : classes.tooltip,
        },
      }}
      placement={isAvailable ? 'bottom' : 'top'}>
      <Button
        sx={{
          ...classes.icon,
          ...classes[className],
          ...(isAvailable ? {} : classes.disabled),
        }}
        startIcon={isAvailable && startIcon}
        endIcon={!isAvailable && <LockIcon sx={classes.lockIcon} />}
        onClick={isAvailable ? handleOnClick : undefined}
        variant={variant}
        disabled={disabled}
        color="inherit">
        {btnText}
      </Button>
    </Tooltip>
  </Box>
);

CustomToolbarAction.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
  btnText: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  className: PropTypes.string,
  startIcon: PropTypes.node,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  isAvailable: PropTypes.bool,
};

export default CustomToolbarAction;
